import * as angular from "angular";
import {IController} from "angular";
import { Webhook } from '../../models/webhook.model';
import * as _ from "lodash";
import {WebhooksDialogService} from "../../services/webhooks-dialog-service.service";
import {WebhooksService} from "../../services/webhooks-service.service";

export class webhooksViewController implements IController {

  private webhooks: Webhook[] = [];

  /* @ngInject */
  constructor(private $log, private webhooksService: WebhooksService, private webhooksDialogService: WebhooksDialogService) {}

  $onInit() {
    this._getWebhooks();
  }

  onCreate($event) {
    this.webhooksDialogService.create($event)
      .then((webhook) => {
        this._create(webhook, $event)
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onEdit(webhook: Webhook, $event) {
    this.webhooksDialogService.edit(webhook, $event)
      .then((updatedWebhook) => {
        this._edit(updatedWebhook, $event)
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onRemove(id) {
    this.webhooksService.remove(id)
      .then((deletedWebhook) => {
        const deletedWebhookIdx = _.findIndex(this.webhooks, (w) => { return w.id === id; });
        this.webhooks.splice(deletedWebhookIdx, 1, deletedWebhook);
      })
      .catch((error) => {
        this.$log.error('Failed to delete the webhook', error);
      })
  }

  private _getWebhooks() {
    this.webhooksService.getAll()
      .then((webhooks) => {
        this.webhooks = webhooks;
      })
      .catch((error) => {
        this.$log.error('Failed to get Webhooks', error);
      })
  }

  private _create(webhook: Webhook, ev) {
    return this.webhooksService.create(webhook, ev)
      .then((newWebhook) => {
        this.webhooks.push(newWebhook);
      })
      .catch((error) => {
        this.$log.error('Failed to create the webhook', error);
      })
  }

  private _edit(updatedWebhook, ev) {
    return this.webhooksService.edit(updatedWebhook, ev)
      .then((webhook) => {
        return webhook
      })
      .catch((error) => {
        this.$log.error('Failed to edit webhook', error);
      })
  }

}

angular
  .module('bringoz.admin.webhooks')
  .component('webhooksView', {
    bindings: {},
    template: require('./webhooks-view.html').default,
    controller: webhooksViewController
  });
